import { create } from 'zustand';

import useClientStore from '../client/useClientStore';
import useWarehouseStore from '../warehouse/useWarehouseStore';
import useUserStore from './userStore';
import useStore from '../asnmobile/useStore';
import useMenuStore from '../menu/useMenuStore';
import { useSearchStore } from '../search/searchStore';


const useLogoutStore = create(() => ({
  resetAllStores: () => {
    useClientStore.getState().reset?.();
    useWarehouseStore.getState().reset?.();
    useUserStore.getState().reset?.();
    useStore.getState().reset?.();
    useMenuStore.getState().reset?.();
    useSearchStore.getState().reset?.();
  }
}));

export default useLogoutStore;